export type NavServiceLogFilterMode = "in" | "out";

const normalizeItems = (items: string[]): string[] =>
    items.map((item) => item.trim()).filter(Boolean);

const lineContains = (line: string, item: string): boolean =>
    line.toLowerCase().includes(item.toLowerCase());

/**
 * Filter log lines by discrete filter items (case-insensitive substring).
 * - `in`: keep lines that contain every item
 * - `out`: drop lines that contain any item
 * Empty items list returns all lines.
 */
export const filterNavServiceLogLines = (
    lines: string[],
    items: string[],
    mode: NavServiceLogFilterMode = "in",
): string[] => {
    const terms = normalizeItems(items);
    if (terms.length === 0) {
        return lines;
    }

    return lines.filter((line) => {
        if (mode === "in") {
            return terms.every((term) => lineContains(line, term));
        }
        return !terms.some((term) => lineContains(line, term));
    });
};
